// in src/MyLayout.js
import React, { useEffect } from 'react';
import { Layout } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from './AppBar';
import SideBar from './SideBar';
import Menu from './Menu';
import { usePermissions } from 'react-admin';
import { removeNoScroll } from '@/actions/Helper';
import WarningStatusTerminal from '@/components/WarningStatusTerminal';

const styles = makeStyles({
  container: {
    margin: '1px 0px 5px 100px',
    padding: '0',
    minHeight: 'calc(90vh - 70px)',
    '@media (max-width:1000px)': {
      margin: '0px 0px 10px 100px',
    },
    '@media (max-width:800px)': {
      margin: '0px 0px 50px 0px',
    },
  },
  adminContainer: {
    margin: '32px 0px 90px 100px',
    '@media (max-width:800px)': {
      margin: '32px 0px 90px 0px !important',
    },
  },
});

export default (props) => {
  const cls = styles();
  const { permissions } = usePermissions();

  useEffect(() => {
    window.scrollTo(0, 0);
    removeNoScroll();
  }, [props.children]);

  return (
    <Layout {...props} appBar={AppBar} sidebar={SideBar} menu={Menu}>
      <WarningStatusTerminal />
      <div
        id="layoutMain"
        className={`${cls.container} ${
          permissions === 'admin' && cls.adminContainer
        }`}>
        {props.children}
      </div>
    </Layout>
  );
};
